/*
 * @Author: CYX
 * @Date: 2020-05-12 11:44:46
 * @LastEditors: CYX
 * @LastEditTime: 2020-07-17 10:05:49
 */ 
export const databaseEn = {
    shouye:'Home page',
    zlglb:'Database list',
    genduo:'more',
    rzfwgjz:'Please enter data key',
    jiansuo:'retrieval',
    sousuo:'search',
    xinxileixin:'Information type',
    qzxcprz:'Compulsory product certification',
    faburiqi:'Release date',
    xunzheriqi:'Selection date',
    zlg:'database',
    zlxq:'Particulars of information',
    weisc:'Not collected',
    yisc:'collected',
    zhiding:'Stick',
    renzhengzx: "The authentication information",
    henyeguifan: "Industry standard",
    zhengcefagui: "Policies and regulations",
    biaozhunziliao: "The standard data",
    caipingzhaohui: "Product recall",
}


// WEBPACK FOOTER //
// ./src/lang/home/database/indexEn.js